import { ControlStateOptions } from "./ControlStateOptions"

/**
 *  Determine the CSS class for the text of a control element.
 */
export function determineControlTextClass(state: ControlStateOptions) {
  if (state.error) {
    return "text-body2/regular text-red-500"
  }

  if (state.success) {
    return "text-body2/regular text-green-500"
  }

  return "text-body2/regular"
}
